

import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {createOtherFee, deleteOtherFee, queryOtherFeeList} from "@/api/purchase-order";

@Component({name: 'poOtherFee'})
export default class extends Vue {
  @Prop({ default: {} }) private row: {} | any;
  @Prop({ default: false }) private show: boolean;

  private addVisible = false;
  private distributionVisible = false;
  private otherFee = 0;
  private orderAmount = 0;
  private loading = false;
  private table = {
    list: [],
    tableCol: [
      {
        label: "费用名称",
        prop: "name",
        key: "name",
        show: true,
        disabled: false,
      },
      {
        label: "金额(人民币)",
        prop: "amount",
        key: "amount",
        show: true,
        disabled: false,
      },
      {
        label: "分配比率",
        prop: "distributionRatio",
        type: "link",
        click: "handleDistributionDetail",
      },
      {
        label: "备注",
        prop: "remark",
        key: "remark",
        show: true,
        disabled: false,
      },
      {
        label: "操作",
        prop: "action",
        type: "icon_delete",
        icon: "el-icon-delete",
        click: "handleDelete",
        show: true,
        disabled: false,
      },
    ]
  };

  private detailTable = {
    list: [],
    tableCol: [
      {
        label: "单据类型",
        prop: "type",
        key: "type",
        show: true,
        disabled: false,
      },
      {
        label: "单据号码",
        prop: "orderCode",
        key: "orderCode",
        show: true,
        disabled: false,
      },
      {
        label: "分配金额",
        prop: "distributeAmount",
        key: "distributeAmount",
        show: true,
        disabled: false,
      },
      {
        label: "分配日期",
        prop: "distributeDate",
        key: "distributeDate",
        show: true,
        disabled: false,
      },
      {
        label: "分配人",
        prop: "distributeUser",
        key: "distributeUser",
        show: true,
        disabled: false,
      },
    ]
  }

  private addForm = {
    item: [
      {
        label: "名称",
        prop: "name",
        key: "name",
        type: "input",
        rules: [
          {
            required: true,
            message: "请填写到费用名称",
            trigger: "blur",
          },
        ],
        placeholder: "请输入费用名称",
        clearable: true,
        maxlength: 10,
      },
      {
        label: "金额",
        prop: "amount",
        key: "amount",
        type: "inputNumber",
        precision: 2,
        rules: [
          {
            required: true,
            message: "请填写到金额",
            trigger: "blur",
          },
        ],
        placeholder: "请输入金额",
        clearable: true,
      },
      {
        label: "备注",
        prop: "remark",
        key: "remark",
        type: "textarea",
        rows: "3",
        placeholder: "请输入备注",
        clearable: true,
      },
    ],
    data: {}
  };

  @Watch('show')
  private async getOtherFeeList() {
    if (this.show) {
      try {
        this.loading = true;
        this.table.list = await queryOtherFeeList({purchaseOrderId: this.row.id}) as any;
        this.otherFee = this.table.list.map(item => item.amount).reduce((total, num) => total + num, 0);
        this.orderAmount = this.row.orderAmount + this.otherFee;
      } catch (error) {
        this.$message.error(error);
      } finally {
        this.loading = false;
      }
    }
  }

  private handleAdd() {
    this.addVisible = true;
  }

  private close() {
    this.$emit("close");
  }

  private addDialogClose() {
    this.clearForm();
    this.addVisible = false;
  }

  private clearForm() {
    this.addForm.data = {};
  }

  private async addDialogSubmit() {
    (this.$refs.addForm as any).$refs.ruleForm.validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          ...this.addForm.data,
          purchaseOrderId: this.row.id,
          orderAmount: this.row.orderAmount,
        }
        await createOtherFee(params)
        this.$message({
          message: '添加成功',
          type: 'success'
        });
        this.clearForm();
        this.addVisible = false
        await this.getOtherFeeList()
      }
    })
  }

  // 分配详情
  private handleDistributionDetail(scope) {
    console.log(scope)
    this.detailTable.list = scope.row.distributionDetail;
    this.distributionVisible = true;
  }

  // 删除
  private async handleDelete(scope) {
    console.log(scope)
    await deleteOtherFee({id: scope.row.id});
    this.$message({
      message: '删除成功',
      type: 'success'
    });
    await this.getOtherFeeList();
  }
}
